module.exports = __webpack_public_path__ + "img/b6.73267a89.jpg";